import React from "react";

import { UTCToDateTimeFormatWithoutSecondsForInbox } from "../../../../../shared";
import ReactMarkdownComponent from "../../../../../shared/components/reactMarkdownComponent/reactMarkdownComponent";

const ReceiveMessageComponent = (props) => {
  const { message, selectedConversation, key } = props;

  return (
    <div className="message-div mx-2" key={key}>
      <div className="received-message ms-2  mt-3 rounded-top-5 rounded-end-5">
        <div className="text-black chat-text py-2 px-4">
          <ReactMarkdownComponent message={message.message} />
        </div>
      </div>
      <div className="text-start">
        <small className="text-start mx-2 sender-name">
          <strong>{selectedConversation?.customerName} </strong>
          <span className="fw-lighter text-secondary">
            {UTCToDateTimeFormatWithoutSecondsForInbox(
              Number(message.createdAt)
            )}
          </span>
        </small>
      </div>
    </div>
  );
};

export default React.memo(ReceiveMessageComponent);
